import { FC } from "react";
import { BillingCostNoDataChip } from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/billing-cost/BillingCostNoDataChip";

export const BudgetNoCollectedDataChip: FC = () => (
  <BillingCostNoDataChip title="N/A" tooltipTitle={tooltipTitle} />
);

const tooltipTitle =
  "The latest billing data is not yet available as it’s still being processed by your cloud provider";
